import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon BuyItAgainIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const BuyItAgainIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <g clipPath="url(#clip0_2232_5041)">
        <path
          d="M6.86072 6.28369H17.4365C18.0016 6.28374 18.4999 6.79207 18.5 7.40186V16.9365C18.5 17.5237 18.0237 17.9999 17.4365 18H6.86072C6.27349 18 5.79724 17.5237 5.79724 16.9365V7.40186C5.79728 6.79204 6.29559 6.28369 6.86072 6.28369Z"
          stroke="#503291"
        />
        <path d="M6.29749 10.7839H10.019H10.7081" stroke="#503291" />
        <path d="M14.2975 10.7839H17.9253H18.5971" stroke="#503291" />
        <path
          d="M10.3632 6.78394C10.3632 6.78394 10.2829 12.0222 10.2992 12.3013C10.3154 12.5803 10.3632 12.4941 10.3632 12.4941L12.0501 10.986L14.3789 12.4268C14.3789 12.4268 14.5598 12.5336 14.5801 12.3787C14.6003 12.2238 14.5801 6.78394 14.5801 6.78394H10.3632Z"
          stroke="#503291"
        />
        <path
          d="M6.57726 0.642071L8.5 2.5L6.57726 4.14207"
          stroke="#503291"
          strokeLinecap="round"
        />
        <path
          d="M0.57157 5.7031C0.5708 5.68756 0.450475 3.18838 3.10562 2.59609C3.91475 2.41098 5.12419 2.49105 5.75831 2.5C6.72427 2.51178 7.25019 2.5 8 2.5"
          stroke="#503291"
          strokeLinecap="round"
        />
        <path
          d="M17 23.5L15.0772 21.6421L17 20.0701"
          stroke="#503291"
          strokeLinecap="round"
        />
        <path
          d="M23.5 18.5C23.5008 18.5155 23.6211 21.0147 20.966 21.607C20.1569 21.7921 18.9474 21.712 18.3133 21.7031C17.3473 21.6913 16.8214 21.7031 16.0716 21.7031"
          stroke="#503291"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2232_5041">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
export default BuyItAgainIcon
